import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconContrast } from '../../../base/icons/svg';
import { inklusivaContextMenuStyles } from '../../../inklusiva/ui-constants';
import { CONTRAST_SLIDER_MAXIMUM, CONTRAST_SLIDER_MINIMUM } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        ...inklusivaContextMenuStyles(theme)
    };
});
const _onClick = (e) => {
    e.stopPropagation();
};
const ContrastSlider = ({ initialValue, label, onChange }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const [contrast, setContrast] = useState(initialValue || 1);
    const _onContrastSliderChange = useCallback((event) => {
        const newContrast = event.currentTarget.value;
        onChange(newContrast);
        setContrast(Number(newContrast));
    }, [onChange]);
    return (React.createElement("div", { "aria-label": t('contrastSlider'), className: classes.contextMenuSlider },
        React.createElement("label", { className: classes.contextMenuSliderLabel, htmlFor: 'contrast-slider-input' }, label),
        React.createElement("div", { className: cx('popupmenu__contents', classes.contextMenuSliderInner), onClick: _onClick },
            React.createElement("span", { className: classes.contextMenuSliderIcon },
                React.createElement(Icon, { size: 22, src: IconContrast })),
            React.createElement("input", { "aria-label": label, id: 'contrast-slider-input', "aria-valuemax": CONTRAST_SLIDER_MAXIMUM, "aria-valuemin": CONTRAST_SLIDER_MINIMUM, "aria-valuenow": contrast, max: CONTRAST_SLIDER_MAXIMUM, min: CONTRAST_SLIDER_MINIMUM, onChange: _onContrastSliderChange, tabIndex: 0, type: 'range', value: contrast }))));
};
export default ContrastSlider;
